import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ParallaxModule, ParallaxConfig } from 'ngx-parallax';
import {ScrollToModule} from 'ng2-scroll-to';

import {AppRoutes} from './app.routes';
import { AppComponent } from './app.component';
import { MainComponent } from './main/main.component';
import { SectionComponent } from './section/section.component';
import { MenuComponent } from './menu/menu.component';
import { AboutComponent } from './about/about.component';
import { EducationComponent } from './education/education.component';
import { PortfolioComponent } from './portfolio/portfolio.component';
import { ContactComponent } from './contact/contact.component';


@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    SectionComponent,
    MenuComponent,
    AboutComponent,
    EducationComponent,
    PortfolioComponent,
    ContactComponent
  ],
  imports: [
    RouterModule.forRoot(AppRoutes),
    BrowserModule,
    ParallaxModule,
    ScrollToModule.forRoot(),
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// /Users/davcocom/Documents/Documents - David’s MacBook Pro/resume/resume-onepage/src/app/app.module.ts